import { render, staticRenderFns } from "./unathorized-tv-list.vue?vue&type=template&id=8facf9a0&"
import script from "./unathorized-tv-list.vue?vue&type=script&lang=ts&"
export * from "./unathorized-tv-list.vue?vue&type=script&lang=ts&"
import style0 from "./unathorized-tv-list.vue?vue&type=style&index=0&id=8facf9a0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports